"use strict";

const HOME_PAGE_TEMPLATE = `
    <section id="banner-component"></section>
    <section id="bookCollection" class="container"></section>
	<div class="clearfix"></div>
	<div class="col-lg-12 center">
		<i class="fa fa-refresh fa-3x reload-themes"></i>
	</div>
`;

const HomePage = Backbone.View.extend({

    id: "home-page",

    components: {
        banner: {},
        themeCollectionView: {},
    },
    
    template: _.template(HOME_PAGE_TEMPLATE),

	events: {
        "click i.reload-themes" : "refresh",
    },

    afterRender: function() {
        this.components.banner.afterRender();
    },

    animate: function() {
        BookCollectionView.animate(".bookContainer");
        ThemeComponent.animate(".theme-icon");
    },
    
    initialize: function() {
        this.resetThemes();
        this.listenTo(this.themes, "update reset destroy", this.animate);
        this.components.themeCollectionView = new ThemeCollectionView({ collection: this.themes });
        this.components.banner = new BannerComponent();
    },

    resetThemes: function() {
        var themes;

        // Select five random themes from the collection
        themes = this.collection.shuffle().slice(0, 5);
        if (this.themes) {
            this.themes.set(themes);
        } else {
            this.themes = new Backbone.Collection(themes);
        }
    },

    render: function() {
        this.$el.html(this.template());
        this.$el.find("#bookCollection").html(this.components.themeCollectionView.render().el);
        this.$el.find("#banner-component").html(this.components.banner.render().el);

        this.animate();

        return this;
    },

    // Refresh the themes and their books
    refresh: function() {
        let bannerContainer = $(".banner-container")[0];
        this.resetThemes();
        // Scroll the page below the banner
        var scrollPosition = bannerContainer.clientHeight + bannerContainer.offsetTop;
        $("html, body").animate({ scrollTop: scrollPosition }, "slow");
        
        this.animate();
    }

});